import React, { useEffect, useState } from 'react';
import { Button, Tabs } from 'flowbite-react';
import Validate from '../shared/validation/Validate';
import UpdateCurrencyRates from '../shared/Settings/UpdateCurrencyRates';
import EmployeeWorkHours from '../shared/Settings/EmployeeWorkHours';
import Employees from '../shared/Settings/Employees';
import Shops from '../shared/Settings/Shops';
import { useNavigate } from 'react-router-dom';
import CustomerDetail from '../shared/Settings/CustomerDetail';

const theme = {
  "base": "flex flex-col gap-2",
  "tablist": {
    "base": "flex text-center",
    "styles": {
      "pills": "flex-wrap font-medium text-sm bg-headings pl-3 text-white rounded-lg space-x-2",
    },
    "tabitem": {
      "base": "flex items-center justify-center p-4 rounded-t-lg text-sm font-medium first:ml-0 disabled:cursor-not-allowed disabled:text-gray-400 disabled:dark:text-gray-500",
      "styles": {
        "pills": {
          "base": "",
          "active": {
            "on": "rounded-lg bg-white/10 text-white",
            "off": "rounded-lg hover:bg-white/10"
          }
        },
      },
      "icon": "mr-2 h-5 w-5"
    }
  },
  "tabitemcontainer": {
    "base": "",
    "styles": {
      "default": "",
      "underline": "",
      "pills": "",
      "fullWidth": ""
    }
  },
  "tabpanel": "py-3"
}


function Settings() {

  const navigate = useNavigate();

  // userDatail  for API request
  const userDetail = JSON.parse(window.localStorage.getItem("auth"))?.user;

  useEffect(() => {
    if (userDetail && userDetail.userRole !== 'Admin') {
      navigate('/buying-currency');
    }
  }, [])

  useEffect(() => {
    if (userDetail && userDetail.userRole === 'Admin' && userDetail.shopId === undefined) {
      navigate('/shopSelection');
    }
  }, [])

  return (
    <Validate >
      <Tabs aria-label="" theme={theme} style={'pills'} className='w-full'>
        <Tabs.Item active title="Upload New Rates" className='text-xl'>
          <div className="text-sm text-gray-500 dark:text-gray-400">
            <UpdateCurrencyRates />
          </div>
        </Tabs.Item>
        <Tabs.Item title="Shops">
          <div className="text-sm text-gray-500 dark:text-gray-400">
            <Shops />
          </div>
        </Tabs.Item>
        <Tabs.Item title="Employees">
          <div className="text-sm text-gray-500 dark:text-gray-400">
            <Employees />
          </div>
        </Tabs.Item>
        <Tabs.Item title="Customer Detail">
          <div className="text-sm text-gray-500 dark:text-gray-400">
            <CustomerDetail />
          </div>
        </Tabs.Item>
        {/* <Tabs.Item title="Employee History">
          <div className="text-sm text-gray-500 dark:text-gray-400">
            <EmployeeWorkHours />
          </div>
        </Tabs.Item> */}
      </Tabs>
    </Validate>
  );
}

export default Settings;